module.exports = __webpack_public_path__ + "img/2x UHF-DVS-50.10842e1e.svg";